/* Salah on the Go — chat button, matched to the old Wix chat.
 *
 * Wix's: a navy CIRCLE holding a SOLID cream speech balloon with a tail at the
 * lower-left and two navy bars. Shopify Inbox ships a rounded cream pill reading
 * "Chat" with a thin outline bubble.
 *
 * Shape and colour come from base.css via shopify-chat::part(activator). Everything
 * else has to happen inside the shadow root, because ::part() selects only the part
 * itself — you cannot use a descendant selector after it — and the activator's
 * children (.activator__icon, .activator__label, .activator__indicator) are not
 * exposed as parts.
 *
 * The icon is drawn as a CSS background-image rather than by rewriting the <svg>.
 * Rewriting worked but Inbox rebuilds the activator when the panel closes, and for a
 * frame or two you saw the original pill — outline icon and the word "Chat" — inside
 * the circle. As CSS it applies the instant the element exists, with no JS race.
 *
 * CRITICAL: every rule is scoped to :host(:not([open])). When the chat opens, Inbox
 * shrinks the activator and tucks it into the panel — on a phone the panel is
 * full-screen and it lands on the SEND button. Styling it unconditionally made "send"
 * close the chat.
 */
(function () {
  'use strict';

  var NAVY = '%232f4f76';
  var CREAM = '%23fbf8f4';
  var ICON =
    "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E" +
    "%3Cpath fill='" + CREAM + "' d='M16 5.2c-6.05 0-10.95 4.05-10.95 9.05 0 2.85 1.6 5.4 4.1 7.05" +
    "-.2 1.6-.9 3.25-2.3 4.75-.3.32-.02.84.4.75 2.6-.52 4.6-1.7 5.85-2.7.94.2 1.9.3 2.9.3 6.05 0 " +
    "10.95-4.05 10.95-9.05S22.05 5.2 16 5.2z'/%3E" +
    "%3Crect x='11.4' y='12.35' width='9.2' height='1.9' rx='.95' fill='" + NAVY + "'/%3E" +
    "%3Crect x='11.4' y='15.85' width='9.2' height='1.9' rx='.95' fill='" + NAVY + "'/%3E%3C/svg%3E\")";

  var CSS = [
    ':host(:not([open])) .activator {',
    '  display: flex !important;',
    '  align-items: center !important;',
    '  justify-content: center !important;',
    '  gap: 0 !important;',
    '}',
    ':host(:not([open])) .activator__label,',
    ':host(:not([open])) .activator__indicator { display: none !important; }',
    ':host(:not([open])) .activator__icon {',
    '  width: 30px !important;',
    '  height: 30px !important;',
    '  background-image: ' + ICON + ' !important;',
    '  background-size: contain !important;',
    '  background-repeat: no-repeat !important;',
    '  background-position: center !important;',
    '}',
    // the glyph is a <shopify-chat-icon> custom element with its own shadow root,
    // not a bare <svg> — hiding 'svg' never matched it and both bubbles drew
    ':host(:not([open])) .activator__icon > * { display: none !important; }',
  ].join('\n');

  // The activator does not stay put: it starts in shopify-chat's shadow root and, once
  // the agent runtime boots, moves into <shopify-agent-runtime>'s own shadow root — a
  // separate style scope. Injecting into shopify-chat alone meant the button reverted
  // to the default pill after the first open/close. So inject into EVERY shadow root
  // that holds an .activator. Both hosts carry the `open` attribute, so the same
  // :host(:not([open])) scoping is correct in either place.
  var PRECHAT_CSS = [
    'input[type="tel"], [data-testid="phone-input"], .phone-input, .field--phone {',
    '  display: none !important;',
    '}'
  ].join('\n');

  function inject(root) {
    if (!root || root.querySelector('style[data-sotg]')) return;
    var st = document.createElement('style');
    st.setAttribute('data-sotg', '1');
    st.textContent = CSS + '\n' + PRECHAT_CSS;
    root.appendChild(st);
  }

  function apply(host) {
    var root = host && host.shadowRoot;
    if (!root) return;
    var seen = [];
    (function walk(r, depth) {
      if (!r || depth > 5) return;
      if (r.querySelector('.activator')) { inject(r); seen.push(r); }
      var kids = r.querySelectorAll('*');
      for (var i = 0; i < kids.length; i++) if (kids[i].shadowRoot) walk(kids[i].shadowRoot, depth + 1);
    })(root, 0);
    return seen.length;
  }

  var tries = 0;
  var timer = setInterval(function () {
    var host = document.querySelector('shopify-chat');
    if (host && host.shadowRoot) {
      clearInterval(timer);
      apply(host);
      // Inbox wipes and rebuilds the shadow tree on open/close — put the style back
      var reapply = function () { apply(host); };
      new MutationObserver(reapply).observe(host.shadowRoot, { childList: true, subtree: true });
      new MutationObserver(reapply).observe(host, { attributes: true, attributeFilter: ['open'] });
      // the runtime's shadow tree is rebuilt on close, taking the style with it
      setInterval(reapply, 1000);
      return;
    }
    if (++tries > 40) clearInterval(timer);
  }, 500);
})();
